import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import { calcularIcms } from "core/utils/calcularIcms.ts";
import { currencyToNumber } from "core/utils/currencyToNumber.ts";
import { AnimatePresence } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import ModalCadastro from "../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalHistoricoEdicao from "../../../components/ModalHistoricoEdicao/ModalHistoricoEdicao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import FiltrosRedux from "../../../contexts/Filtros.js";
import MultiplosFiltrosRedux from "../../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import { normalizeCurrency } from "../../../core/utils/normalizeCurrency.ts";
import {
	getDependenciasPedidos,
	getPedidosGeral,
} from "../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraPedido,
	deletePedidoPorId,
	editaPedidoPorId,
	getHistoricoPedido,
	getNumeroSeguintePedido,
	getPedidoExiste,
	getPedidoPorId,
} from "../../../services/ModuloGerenciador/Pedido";
import { getPedidoSearch } from "../../../services/ModuloGerenciador/Search";
import { getTaxaIcmsPorUf } from "../../../services/ModuloGerenciador/TaxaIcms";
import { buscaKmCoordenadas } from "../../../services/ModuloRastreamento/RotaGoogle";
import { colunasHistorico, itensFiltro } from "./Constants.js";
import PedidoList from "./FormPedido.js";
import "./Pedido.css";

const validateField = (field, value, setValid) => {
	if (!value || value === "" || value === "false") {
		setValid(false);
		return false;
	}
	setValid(true);
	return true;
};

const normalizeString = (str) => {
	return str
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.trim()
		.toLowerCase();
};

function Pedido(props) {
	const {
		profile,
		hasRegra,
		buscarNumeroSolicitacoes,
		shouldSearchDependencies,
	} = useProfile();

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setDadosTabela(dadosTabelaCopia);
		setTimeout(() => {
			setLoading(false);
		}, 100);
	};

	const [loadingCadastro, setLoadingCadastro] = useState(false);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [dadosTabelaCopia, setDadosTabelaCopia] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [valuesSelect, setValuesSelect] = useState([]);

	const [clientesKm, setValuesClientesKm] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const [openCadastroRota, setOpenCadastroRota] = useState(false);

	const [openCadastroCliente, setOpenCadastroCliente] = useState(false);

	const [openHistoricoEdicao, setOpenHistoricoEdicao] = useState(false);

	const [disablePedido, setDisablePedido] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const handleCloseCadastroRota = (value) => {
		if (idAtual) {
			setOpenCadastroRota(false);
		} else {
			setLoadingSelectRota(true);
			buscarDependenciasCadastroSemLoading();
			setOpenCadastroRota(false);
		}
	};

	const handleCloseCadastroCliente = (value) => {
		if (idAtual) {
			setOpenCadastroCliente(false);
		} else {
			setLoadingSelectCliente(true);
			buscarDependenciasCadastroSemLoading();
			setOpenCadastroCliente(false);
		}
	};

	const handleCloseHistoricoEdicao = (value) => {
		setOpenHistoricoEdicao(false);
	};

	const [taxaIcms, setTaxaIcms] = useState();

	const [valoresHistorico, setValoresHistorico] = useState([]);

	const [clientes, setListaClientes] = useState([]);

	const [listaRotas, setListaRotas] = useState([]);

	const [listaValores, setListaValores] = useState([]);

	const [loadingSelectRota, setLoadingSelectRota] = useState(false);

	const [loadingSelectCliente, setLoadingSelectCliente] = useState(false);

	const [openCadastroValorEmbarque, setOpenCadastroValorEmbarque] =
		useState(false);

	const [loadingSelectValorEmbarque, setLoadingSelectValorEmbarque] =
		useState(false);

	const [pedidoValido, setPedidoValido] = useState(true);

	const [tipoRotaValido, setTipoRotaValido] = useState(true);

	const [freteFiscalValido, setFreteFiscalValido] = useState(true);

	const [pedagioValido, setPedagioValido] = useState(true);

	const [kmValido, setKMValido] = useState(true);

	const [clienteValido, setClienteValido] = useState(true);

	const [classificacaoValido, setClassificacaoValido] = useState(true);

	const [embarcadorValido, setEmbarcadorValido] = useState(true);

	const [destinatarioValido, setDestinatarioValido] = useState(true);

	const [freteMotoristaValido, setFreteMotoristaValido] = useState(true);

	const [freteNormal, setFreteNormal] = useState(0);

	const customStylesErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const handleCloseCadastroValorEmbarque = (value) => {
		if (idAtual) {
			setOpenCadastroValorEmbarque(false);
		} else {
			setLoadingSelectValorEmbarque(true);
			buscarDependenciasCadastroSemLoading();
			setOpenCadastroValorEmbarque(false);
		}
	};

	const labelRota = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.label.split("@")[0].trim()}
			{values.tipoRota !== data.label && (
				<InfoIcon
					className="info-icon"
					onClick={(e) => {
						e.stopPropagation();
						setIdAtual(data.idRota);
						setDisable(true);
						setOpenCadastroRota(true);
					}}
				/>
			)}
			{values.tipoRota === data.label && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearRota();
					}}
				/>
			)}
		</div>
	);

	const [idAtual, setIdAtual] = useState();

	const [disable, setDisable] = useState(false);

	const buscarSearch = useCallback(async () => {
		if (!profile) return;
		setLoading(true);
		let pesquisaFormatada = `${valuesPesquisa.item}=${
			valuesPesquisa.pesquisa ?? ""
		}`;
		if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
			for (let filtro of multiplosFiltrosRedux) {
				pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
			}
		}
		await getPedidoSearch(profile?.token, pesquisaFormatada)
			.then((result) => {
				setDadosTabela(result.data);
				setLoading(false);
			})
			.catch((error) => {
				if (error.response?.data?.length > 200) {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
				} else {
					setTextoErro(error.response.data);
				}
				setOpenToastErro(true);
				setLoading(false);
			});
	}, [valuesPesquisa, multiplosFiltrosRedux, profile]);

	const buscarNumeroPedido = async () => {
		await getNumeroSeguintePedido(profile?.token)
			.then((result) => {
				setValidator((current) => ({ ...current, validatorPedido: "true" }));
				setValues((current) => ({ ...current, pedido: result.data }));
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarDependencias = async () => {
		setLoading(true);
		setLoadingCadastro(true);
		await getPedidosGeral(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setDadosTabelaCopia(result.data);
				setTabelaRedux({});
				setLoadingCadastro(false);
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectValorEmbarque(false);
				if (props.telaCadastro !== true) {
					setLoading(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarDependenciasCadastro = async () => {
		setLoadingSelectRota(true);
		setLoadingSelectCliente(true);
		setLoadingSelectValorEmbarque(true);
		await getDependenciasPedidos(profile?.token)
			.then((result) => {
				setListaClientes(result.data.clientes);
				filtraClientes();
				setListaRotas(result.data.rotas);
				setListaValores(result.data.valoresEmbarque);
				setTabelaRedux({});
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectValorEmbarque(false);
				if (props.telaCadastro === true) {
					setLoading(false);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectValorEmbarque(false);
			});
	};

	const buscarDependenciasCadastroSemLoading = async () => {
		await getDependenciasPedidos(profile?.token)
			.then((result) => {
				setListaClientes(result.data.clientes);
				filtraClientes();
				setListaRotas(result.data.rotas);
				setDadosTabela(result.data.pedidos);
				setListaValores(result.data.valoresEmbarque);
				setTabelaRedux({});
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectValorEmbarque(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoadingSelectRota(false);
				setLoadingSelectCliente(false);
				setLoadingSelectValorEmbarque(false);
			});
	};

	const handleChangeFreteNormal = useCallback(() => {
		const freteFiscal = currencyToNumber(values?.freteFiscal);
		const icms = currencyToNumber(values?.icms);
		const pedagio = currencyToNumber(values?.pedagio);
		const classificacao = currencyToNumber(values?.classificacao);

		const valor = values.icmsEmbarcador
			? freteFiscal + pedagio + classificacao
			: freteFiscal + icms + pedagio + classificacao;

		if (!isNaN(valor)) {
			setFreteNormal(normalizeCurrency(valor));
			setValues((current) => ({
				...current,
				freteNormal: normalizeCurrency(valor),
			}));
		}
	}, [
		values?.freteFiscal,
		values?.icms,
		values?.pedagio,
		values?.classificacao,
		values?.icmsEmbarcador,
	]);

	useEffect(() => {
		if (!loading) {
			filtraClientes();
		}
	}, [loading]);

	useEffect(() => {
		filtraClientes();
	}, [clientes]);

	useEffect(() => {
		if (dadosRequestControllerRedux === "Fechar Modal Cliente") {
			handleCloseCadastroCliente();
			setDadosRequestControllerRedux("");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Rota") {
			handleCloseCadastroCliente();
			setDadosRequestControllerRedux("");
			setTextoSucesso("Cadastrado Com Sucesso");
			setOpenToastSucesso(true);
		}
	}, [dadosRequestControllerRedux]);

	useEffect(() => {
		if (clientesKm.idClienteOrigem && clientesKm.idClienteDestino) {
			buscarKm();
		}
	}, [clientesKm]);

	useEffect(() => {
		handleChangeFreteNormal();
	}, [handleChangeFreteNormal]);

	useEffect(() => {
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
		}));
		setValidator((current) => ({
			...current,
			validatorPedido: "false",
			validatorTipoRota: "false",
			validatorKM: "false",
			validatorCliente: "false",
			validatorEmbarcador: "false",
			validatorDestinatario: "false",
			validatorFreteMotorista: "false",
		}));
	}, [loading]);

	const [dadosFiltradosClientes, setDadosFiltradosClientes] = useState([]);

	const filtraClientes = () => {
		var dadosfiltraclientes = clientes;
		dadosfiltraclientes.sort(function (a, b) {
			if (a.nomeFantasia < b.nomeFantasia) {
				return -1;
			} else {
				return true;
			}
		});
		setDadosFiltradosClientes(dadosfiltraclientes);
	};

	const dadosOrdenadosClientes = dadosFiltradosClientes;

	const buscarTaxaIcms = async (ufOrigem, ufDestino) => {
		await getTaxaIcmsPorUf(profile?.token, ufOrigem, ufDestino)
			.then((result) => {
				let taxaIcmsAqui = result?.data?.[0]?.taxa;
				if (typeof taxaIcmsAqui === "string") {
					taxaIcmsAqui = taxaIcmsAqui
						.replace(/\./g, "")
						.replace(",", ".")
						.trim();
					taxaIcmsAqui = parseFloat(taxaIcmsAqui);
				}
				let newTaxa = 0;
				if (!isFinite(taxaIcmsAqui) || !taxaIcmsAqui) {
					newTaxa = 0;
					setValues((current) => ({ ...current, icms: "0,00" }));
				} else {
					newTaxa = taxaIcmsAqui / 100;
				}
				setTaxaIcms(newTaxa);
			})
			.catch(() => {
				setTextoErro("Rota não Possui Taxa de Icms.");
				setValues((current) => ({ ...current, icms: "0,00" }));
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const buscarKm = async () => {
		await buscaKmCoordenadas(clientesKm, profile?.token)
			.then((result) => {
				setValues((current) => ({
					...current,
					km: result.data.toString().split(".")[0],
				}));
				setKMValido(true);
				setValidator((current) => ({ ...current, validatorKM: "true" }));
				setTextoSucesso(
					`Distância calculada com sucesso: ${
						result.data.toString().split(".")[0]
					} km`,
				);
				setOpenToastSucesso(true);
			})
			.catch(() => {
				setTextoErro(
					"Embarcador ou Destinatário não possui endereço cadastrado para calcular o Km.",
				);
				setOpenToastErro(true);
				setLoading(false);
			});
	};

	const verificaPedidoExiste = async () => {
		await getPedidoExiste(
			profile?.token,
			values.pedido,
			values.tipoRota,
			values.cliente,
			values.embarcador,
			values.destinatairo,
		)
			.then((result) => {
				setTextoSucesso(result.data);
				setOpenToastSucesso(true);
				setValidator((current) => ({
					...current,
					validatorPedido: "true",
				}));
				setPedidoValido(true);
			})
			.catch((error) => {
				setValidator((current) => ({
					...current,
					validatorPedido: "false",
				}));
				setPedidoValido(false);
				setTextoErro(error.response.data);
				setOpenToastErro(true);
			});
	};

	useEffect(() => {
		if (clientesKm.idClienteOrigem && clientesKm.idClienteDestino) {
			buscarKm();
		}
	}, [clientesKm]);

	const buscarHistoricoPedido = async (codigo) => {
		await getHistoricoPedido(codigo, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setValoresHistorico(result.data);
					setOpenHistoricoEdicao(true);
				}
			})
			.catch((error) => {
				setTextoErro(error.response.data);
				setOpenToastErro(true);
			});
	};

	const handleCalcularIcms = useCallback(() => {
		setValidator((current) => ({
			...current,
			validatorFreteFiscal: "true",
			validatorClassificacao: "true",
			validatorPedagio: "true",
		}));
		setFreteFiscalValido(true);
		setClassificacaoValido(true);
		setPedagioValido(true);
		const freteFiscal = calcularIcms(values.freteFiscal, taxaIcms);
		setValues((current) => ({ ...current, icms: freteFiscal }));
	}, [values.freteFiscal, taxaIcms]);

	const validationRules = useMemo(() => {
		return {
			pedido: { value: values.pedido, setValid: setPedidoValido },
			tipoRota: { value: values.tipoRota, setValid: setTipoRotaValido },
			freteFiscal: {
				value: values.freteFiscal,
				setValid: setFreteFiscalValido,
			},
			pedagio: { value: values.pedagio, setValid: setPedagioValido },
			km: { value: values.km, setValid: setKMValido },
			cliente: { value: values.cliente, setValid: setClienteValido },
			classificacao: {
				value: values.classificacao,
				setValid: setClassificacaoValido,
			},
			destinatario: {
				value: values.destinatario,
				setValid: setDestinatarioValido,
			},
			embarcador: { value: values.embarcador, setValid: setEmbarcadorValido },
			freteMotorista: {
				value: values.freteMotorista,
				setValid: setFreteMotoristaValido,
			},
		};
	}, [values]);

	const handleValidators = useCallback(() => {
		let isValid = true;

		Object.keys(validationRules).forEach((key) => {
			const { value, setValid } = validationRules[key];
			if (!validateField(key, value, setValid)) {
				isValid = false;
			}
		});

		return isValid;
	}, [validationRules]);

	useEffect(() => {
		if (
			!taxaIcms ||
			taxaIcms === "0,00" ||
			taxaIcms === "0,0" ||
			values.icmsEmbutido
		) {
			setValues((current) => ({ ...current, icms: "0,00" }));
			return;
		}
		handleCalcularIcms();
	}, [taxaIcms, handleCalcularIcms, values.icmsEmbutido]);

	const cadastrar = async () => {
		if (validator.validatorPedido === "false" || !pedidoValido) {
			setTextoErro("Pedido inválido ou já cadastrado!");
			setOpenToastErro(true);
			setLoading(false);
			return;
		}
		if (!handleValidators()) {
			setTextoErro("Há campos obrigatórios não preenchidos!");
			setOpenToastErro(true);
			setLoading(false);
			return;
		}

		values.freteFiscal = normalizeCurrency(values.freteFiscal);
		values.pedagio = normalizeCurrency(values.pedagio);
		values.classificacao = normalizeCurrency(values.classificacao);
		values.freteMotorista = normalizeCurrency(values.freteMotorista);
		if (
			values.icms === "0.00" ||
			values.icms === undefined ||
			values.icms === null ||
			values.icms === "SemTaxa" ||
			values.icms === ""
		) {
			setTextoErro("Não há taxa no pedido!");
			setOpenToastErro(true);
			return;
		}
		values.pedido = parseInt(values.pedido);
		if (
			values.observacao === "" ||
			values.observacao === null ||
			!values.observacao
		) {
			setValues((current) => ({ ...current, observacao: "" }));
		}
		setValues((current) => ({ ...current, icms: values.icms.toString() }));
		await cadastraPedido(values, profile?.token)
			.then((result) => {
				setLoading(true);
				if (result.status === 200) {
					setTelaCadastro(false);
					shouldSearchDependencies();
					buscarNumeroSolicitacoes();
					setValues({});
					setValuesSelect({});
					buscarDependencias();
					setDadosRequestControllerRedux("Fechar Modal Pedido");
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
				}
			});

		buscarNumeroSolicitacoes();
		setLoading(false);
	};

	const editar = useCallback(async () => {
		if (!handleValidators()) {
			setTextoErro("Há campos obrigatórios não preenchidos!");
			setOpenToastErro(true);
			setLoading(false);
			return;
		}
		values.freteFiscal = normalizeCurrency(values.freteFiscal);
		values.pedagio = normalizeCurrency(values.pedagio);
		values.classificacao = normalizeCurrency(values.classificacao);
		values.freteMotorista = normalizeCurrency(values.freteMotorista);
		if (
			values.icms === "0.00" ||
			values.icms === undefined ||
			values.icms === null ||
			values.icms === "SemTaxa" ||
			values.icms === ""
		) {
			setTextoErro("Não há taxa no pedido!");
			setOpenToastErro(true);
			return;
		}
		values.pedido = parseInt(values.pedido);
		if (
			values.observacao === "" ||
			values.observacao === null ||
			!values.observacao
		) {
			setValues((current) => ({ ...current, observacao: "" }));
		}
		setValues((current) => ({ ...current, icms: values.icms.toString() }));
		setLoading(true);
		await editaPedidoPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (!valuesPesquisa.pesquisa) {
						buscarDependencias();
					} else {
						buscarSearch();
					}
					setTabelaRedux({});
					setTextoSucesso("Editado Com Sucesso");
					setOpenToastSucesso(true);
					setEditando(false);
					setTelaCadastro(false);
					setValues({});
					setValuesSelect({});
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
			});

		buscarNumeroSolicitacoes();
		setLoading(false);
	}, [
		values,
		handleValidators,
		valuesPesquisa.pesquisa,
		buscarSearch,
		profile?.token,
	]);

	const preencherDadosEditando = (result) => {
		const tipoRotaSelecionada = opcoesRota.find(
			(option) => option.nome === result.data.tipoRota,
		);
		if (tipoRotaSelecionada) {
			setValuesSelect((current) => ({
				...current,
				tipoRota: tipoRotaSelecionada,
			}));
			setValues((current) => ({
				...current,
				rotaId: tipoRotaSelecionada.idRota,
			}));
		}
		const clienteSelecionado = clientes.find(
			(option) =>
				option.nomeFantasia === result.data.cliente ||
				option.apelido === result.data.cliente,
		);
		if (clienteSelecionado) {
			setValuesSelect((current) => ({
				...current,
				cliente: {
					value: clienteSelecionado.nomeFantasia,
					label: `${clienteSelecionado.nomeFantasia} | ${
						clienteSelecionado.apelido
							? clienteSelecionado.apelido
							: "Favor, cadastrar apelido de Cliente"
					}`,
					id: clienteSelecionado.idCliente,
				},
			}));
			setValues((current) => ({
				...current,
				clienteId: clienteSelecionado.idCliente,
			}));
			setValuesSelect((current) => ({
				...current,
				labelCliente: `${clienteSelecionado.nomeFantasia} | ${
					clienteSelecionado.apelido
						? clienteSelecionado.apelido
						: "Favor, cadastrar apelido de Cliente"
				}`,
			}));
		}
		const destinatarioSelecionado = clientes.find(
			(option) =>
				option.nomeFantasia === result.data.destinatario ||
				option.apelido === result.data.destinatario,
		);
		if (destinatarioSelecionado) {
			setValuesSelect((current) => ({
				...current,
				destinatario: {
					value: destinatarioSelecionado.nomeFantasia,
					label: `${destinatarioSelecionado.nomeFantasia} | ${
						destinatarioSelecionado.apelido
							? destinatarioSelecionado.apelido
							: "Favor, cadastrar apelido de Cliente"
					}`,
					id: destinatarioSelecionado.idCliente,
				},
			}));
			setValues((current) => ({
				...current,
				destinatarioId: destinatarioSelecionado.idCliente,
			}));
			setValuesSelect((current) => ({
				...current,
				labelDestinatario: `${destinatarioSelecionado.nomeFantasia} | ${
					destinatarioSelecionado.apelido
						? destinatarioSelecionado.apelido
						: "Favor, cadastrar apelido de Cliente"
				}`,
			}));
		}
		const embarcadorSelecionado = clientes.find(
			(option) =>
				option.nomeFantasia === result.data.embarcador ||
				option.apelido === result.data.embarcador,
		);
		if (embarcadorSelecionado) {
			setValuesSelect((current) => ({
				...current,
				embarcador: {
					value: embarcadorSelecionado.nomeFantasia,
					label: `${embarcadorSelecionado.nomeFantasia} | ${
						embarcadorSelecionado.apelido
							? embarcadorSelecionado.apelido
							: "Favor, cadastrar apelido de Cliente"
					}`,
					id: embarcadorSelecionado.idCliente,
				},
			}));
			setValues((current) => ({
				...current,
				embarcadorId: embarcadorSelecionado.idCliente,
				icmsEmbarcador: result.data.icmsEmbarcador,
			}));
			setValuesSelect((current) => ({
				...current,
				labelEmbarcador: `${embarcadorSelecionado.nomeFantasia} | ${
					embarcadorSelecionado.apelido
						? embarcadorSelecionado.apelido
						: "Favor, cadastrar apelido de Cliente"
				}`,
			}));
		}
		const valorEmbarqueSelecionado = listaValores.find(
			(option) => option.idValorEmbarque === result.data.valorEmbarqueId,
		);
		if (valorEmbarqueSelecionado) {
			setValuesSelect((current) => ({
				...current,
				valorEmbarqueId: {
					value: valorEmbarqueSelecionado.rota.nome,
					label: valorEmbarqueSelecionado.rota.nome,
					id: valorEmbarqueSelecionado.idValorEmbarque,
				},
			}));
			setValues((current) => ({
				...current,
				valorEmbarqueId: valorEmbarqueSelecionado.idValorEmbarque,
			}));
		}
	};

	const buscarPedidoPorId = async (flag) => {
		if (editando) setLoading(true);
		await getPedidoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						buscarTaxaIcms(
							result.data.embarcadorEstado,
							result.data.destinatarioEstado,
						);
						setValues((current) => ({
							...current,
							...result.data,
							km: result.data.km.toString().split(".")[0],
						}));
						preencherDadosEditando(result);
						setLoading(false);
					} else if (flag) {
						buscarHistoricoPedido(result.data.pedido);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarPedidoPorIdModal = async (id) => {
		if (editando) setLoading(true);
		await getPedidoPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					preencherDadosEditando(result);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						);
					}
					setOpenToastErro(true);
				}
			});
	};

	const deletarPedidoPorId = async () => {
		setLoading(true);
		await deletePedidoPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarDependencias();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (!telaCadastro) {
			setTipoRotaValido(true);
			setClienteValido(true);
			setEmbarcadorValido(true);
			setDestinatarioValido(true);
			setKMValido(true);
			setFreteMotoristaValido(true);
			setPedidoValido(true);
			setValidator((current) => ({
				...current,
				validatorPedido: "false",
				validatorTipoRota: "false",
				validatorKM: "false",
				validatorCliente: "false",
				validatorEmbarcador: "false",
				validatorDestinatario: "false",
				validatorFreteMotorista: "false",
			}));
			setValues({
				icmsEmbarcador: false,
				icmsEmbutido: false,
			});
			setValuesSelect({});
		}
	}, [telaCadastro]);

	useEffect(() => {
		if (
			valuesSelect.embarcador?.endereco?.cidade &&
			valuesSelect.destinatario?.endereco?.cidade
		) {
			const embarcadorCidade = normalizeString(
				valuesSelect.embarcador.endereco.cidade,
			);
			const destinatarioCidade = normalizeString(
				valuesSelect.destinatario.endereco.cidade,
			);

			opcoesRota.forEach((rota) => {
				const cidadeOrigem = normalizeString(rota.cidadeOrigem);
				const cidadeDestino = normalizeString(rota.cidadeDestino);

				if (
					embarcadorCidade === cidadeOrigem &&
					destinatarioCidade === cidadeDestino
				) {
					const selectedOption = {
						value: rota.nome,
						label: `${rota.nome}
                                    @ ${rota.cidadeDestinoRota.cidade}
                                    - ${rota.cidadeDestinoRota.abreviacao}
                                    - ${rota.cidadeOrigemRota.cidade}
                                    - ${rota.cidadeOrigemRota.abreviacao}`,
					};
					setValues((current) => ({
						...current,
						rotaId: rota.idRota,
						tipoRota: rota.nome,
					}));
					setValuesSelect((current) => ({
						...current,
						tipoRota: selectedOption,
					}));
				}
			});
		}
	}, [valuesSelect.embarcador, valuesSelect.destinatario]);

	useEffect(() => {
		if (editando) {
			setDisablePedido(true);
			buscarPedidoPorId();
		} else {
			setDisablePedido(false);
		}
	}, [editando]);

	useEffect(() => {
		if (profile?.token) {
			buscarDependencias();
			buscarDependenciasCadastro();
		}
	}, [profile?.token]);

	useEffect(() => {
		if (profile?.token && props.idAtual) {
			buscarPedidoPorIdModal(props.idAtual);
		}
	}, [clientes, listaRotas, profile?.token, props.idAtual]);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const [semAutorizacaoFreteFiscal, setSemAutorizacaoFreteFiscal] =
		useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Pedido"));
			setSemAutorizacaoFreteFiscal(
				!hasRegra("Permitir Alterar Frete Fiscal Viagem"),
			);
		}
	}, [profile?.token]);

	useEffect(() => {
		if (profile?.token && !editando && telaCadastro) {
			buscarNumeroPedido();
		}
	}, [telaCadastro, editando, profile?.token]);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Pedido";
		if (telaCadastro) return "Cadastro de Pedido";
		return "Pedidos";
	}, [editando, telaCadastro]);

	const opcoesRota = useMemo(() => {
		return listaRotas.map((data) => ({
			value: data.nome,
			label: data.nome,
			...data,
		}));
	}, [listaRotas]);

	const estiloRota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const opcoesCliente = dadosOrdenadosClientes.map((data) => ({
		value: `${data.nomeFantasia} | ${data.cnpj} | ${data.cnpj
			.replace(".", "")
			.replace("/", "")
			.replace("-", "")}`,
		label: `${data.nomeFantasia} | ${
			data.apelido ? data.apelido : "Favor, cadastrar apelido de Cliente"
		}`,
		...data,
	}));

	const labelCliente = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.label}
			{valuesSelect.labelCliente !== data.label && (
				<InfoIcon
					className="info-icon"
					onClick={(e) => {
						e.stopPropagation();
						setIdAtual(data.idCliente);
						setDisable(true);
						setOpenCadastroCliente(true);
					}}
				/>
			)}
			{valuesSelect.labelCliente === data.label && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearCliente();
					}}
				/>
			)}
		</div>
	);

	const opcoesEmbarcador = dadosOrdenadosClientes.map((data) => ({
		value: `${data.nomeFantasia} | ${data.cnpj} | ${data.cnpj
			.replace(".", "")
			.replace("/", "")
			.replace("-", "")}`,
		label: `${data.nomeFantasia} | ${
			data.apelido ? data.apelido : "Favor, cadastrar apelido de Cliente"
		}`,
		...data,
	}));

	const labelEmbarcador = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.label}
			{valuesSelect.labelEmbarcador !== data.label && (
				<InfoIcon
					className="info-icon"
					onClick={(e) => {
						e.stopPropagation();
						setIdAtual(data.idCliente);
						setDisable(true);
						setOpenCadastroCliente(true);
					}}
				/>
			)}
			{valuesSelect.labelEmbarcador === data.label && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearEmbarcador();
					}}
				/>
			)}
		</div>
	);

	const opcoesDestinatario = dadosOrdenadosClientes.map((data) => ({
		value: `${data.nomeFantasia} | ${data.cnpj} | ${data.cnpj
			.replace(".", "")
			.replace("/", "")
			.replace("-", "")}`,
		label: `${data.nomeFantasia} | ${
			data.apelido ? data.apelido : "Favor, cadastrar apelido de Cliente"
		}`,
		...data,
	}));

	const labelDestinatario = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.label}
			{valuesSelect.labelDestinatario !== data.label && (
				<InfoIcon
					className="info-icon"
					onClick={(e) => {
						e.stopPropagation();
						setIdAtual(data.idCliente);
						setDisable(true);
						setOpenCadastroCliente(true);
					}}
				/>
			)}
			{valuesSelect.labelDestinatario === data.label && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearDestinatario();
					}}
				/>
			)}
		</div>
	);

	const clearRota = () => {
		setTipoRotaValido(true);
		setValues((current) => ({
			...current,
			rotaId: null,
			tipoRota: "",
		}));
		setValuesSelect((current) => ({ ...current, tipoRota: "" }));
		setValidator((current) => ({
			...current,
			validatorTipoRota: "false",
		}));
	};

	const clearCliente = () => {
		setClienteValido(false);
		setValuesSelect((current) => ({ ...current, cliente: "" }));
		setValuesSelect((current) => ({ ...current, labelCliente: "" }));
		setValues((current) => ({ ...current, cliente: "" }));
		setValues((current) => ({ ...current, clienteId: null }));
		setValidator((current) => ({ ...current, validatorCliente: "false" }));
	};

	const clearEmbarcador = () => {
		setEmbarcadorValido(false);
		setValuesSelect((current) => ({ ...current, embarcador: "" }));
		setValuesSelect((current) => ({ ...current, labelEmbarcador: "" }));
		setValues((current) => ({ ...current, embarcador: "" }));
		setValues((current) => ({ ...current, embarcadorId: null }));
		setValuesClientesKm((current) => ({ ...current, idClienteOrigem: "" }));
		setValidator((current) => ({ ...current, validatorEmbarcador: "false" }));
	};

	const clearDestinatario = () => {
		setDestinatarioValido(false);
		setValuesSelect((current) => ({ ...current, destinatario: "" }));
		setValuesSelect((current) => ({ ...current, labelDestinatario: "" }));
		setValues((current) => ({ ...current, destinatario: "" }));
		setValues((current) => ({ ...current, destinatarioId: null }));
		setValuesClientesKm((current) => ({ ...current, idClienteDestino: "" }));
		setValidator((current) => ({ ...current, validatorDestinatario: "false" }));
	};

	const clearValorEmbarque = () => {
		setValuesSelect((current) => ({ ...current, valorEmbarqueId: null }));
		setValues((current) => ({ ...current, valorEmbarqueId: "" }));
	};

	const location = useLocation();

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				<PedidoList
					telaCadastro={telaCadastro}
					itensFiltro={itensFiltro}
					valuesPesquisa={valuesPesquisa}
					setValuesPesquisa={setValuesPesquisa}
					buscarSearch={buscarSearch}
					limpar={limpar}
					setTelaCadastro={setTelaCadastro}
					setEditando={setEditando}
					dadosTabela={dadosTabela}
					loading={loading}
					values={values}
					tabelaRedux={tabelaRedux}
					setOpen={setOpen}
					setOpenUsuario={setOpenUsuario}
					setTextoSucesso={setTextoSucesso}
					setTextoErro={setTextoErro}
					setOpenToastErro={setOpenToastErro}
					buscarPedidoPorId={buscarPedidoPorId}
					props={props}
					editando={editando}
					disablePedido={disablePedido}
					loadingCadastro={loadingCadastro}
					setValues={setValues}
					setDadosTabela={setDadosTabela}
					dadosTabelaCopia={dadosTabelaCopia}
					setTabelaRedux={setTabelaRedux}
					valuesSelect={valuesSelect}
					setValuesSelect={setValuesSelect}
					opcoesRota={opcoesRota}
					opcoesCliente={opcoesCliente}
					opcoesEmbarcador={opcoesEmbarcador}
					opcoesDestinatario={opcoesDestinatario}
					listaValores={listaValores}
					validator={validator}
					setValidator={setValidator}
					pedidoValido={pedidoValido}
					setPedidoValido={setPedidoValido}
					tipoRotaValido={tipoRotaValido}
					setTipoRotaValido={setTipoRotaValido}
					freteFiscalValido={freteFiscalValido}
					setFreteFiscalValido={setFreteFiscalValido}
					pedagioValido={pedagioValido}
					setPedagioValido={setPedagioValido}
					kmValido={kmValido}
					setKMValido={setKMValido}
					clienteValido={clienteValido}
					setClienteValido={setClienteValido}
					embarcadorValido={embarcadorValido}
					setEmbarcadorValido={setEmbarcadorValido}
					destinatarioValido={destinatarioValido}
					setDestinatarioValido={setDestinatarioValido}
					classificacaoValido={classificacaoValido}
					setClassificacaoValido={setClassificacaoValido}
					freteMotoristaValido={freteMotoristaValido}
					setFreteMotoristaValido={setFreteMotoristaValido}
					taxaIcms={taxaIcms}
					freteNormal={freteNormal}
					semAutorizacaoFreteFiscal={semAutorizacaoFreteFiscal}
					loadingSelectRota={loadingSelectRota}
					loadingSelectCliente={loadingSelectCliente}
					loadingSelectValorEmbarque={loadingSelectValorEmbarque}
					setOpenCadastroRota={setOpenCadastroRota}
					setOpenCadastroCliente={setOpenCadastroCliente}
					setOpenCadastroValorEmbarque={setOpenCadastroValorEmbarque}
					setDisable={setDisable}
					setIdAtual={setIdAtual}
					verificaPedidoExiste={verificaPedidoExiste}
					buscarTaxaIcms={buscarTaxaIcms}
					editar={editar}
					clearValorEmbarque={clearValorEmbarque}
					labelRota={labelRota}
					estiloRota={estiloRota}
					customStylesErro={customStylesErro}
					labelCliente={labelCliente}
					labelEmbarcador={labelEmbarcador}
					labelDestinatario={labelDestinatario}
					setValuesClientesKm={setValuesClientesKm}
					cadastrar={cadastrar}
				/>
			</AnimatePresence>
			<ModalConfirmacao
				titulo="Deletar"
				texto="Deseja Deletar?"
				tituloConfirmar="Confirmar"
				tituloCancelar="Cancelar"
				open={open}
				onClose={handleClose}
				onClick={deletarPedidoPorId}
			/>
			<ModalUsuario
				titulo="Usuário"
				tituloConfirmar="OK"
				open={openUsuario}
				onClose={handleCloseUsuario}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroRota="sim"
				open={openCadastroRota}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroRota}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroCliente="sim"
				open={openCadastroCliente}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroCliente}
			/>
			<ModalCadastro
				titulo="Cadastro"
				tituloConfirmar="OK"
				cadastroValorEmbarque="sim"
				open={openCadastroValorEmbarque}
				idAtual={idAtual}
				desabilitar={disable}
				onClose={handleCloseCadastroValorEmbarque}
			/>
			<ModalHistoricoEdicao
				valueTabela={tabelaRedux}
				valueDados={valoresHistorico}
				valueUnico={values}
				open={openHistoricoEdicao}
				onClose={handleCloseHistoricoEdicao}
				titulo="Histórico"
				classeSelecionado="idPedido"
				colunas={colunasHistorico}
				nome="pedido"
				nomeTable="Pedido"
			/>
			<ToastSucesso
				texto={textoSucesso}
				open={openToastSucesso}
				onClose={handleCloseToastSucesso}
			/>
			<ToastErro
				texto={textoErro}
				open={openToastErro}
				onClose={handleCloseToastErro}
			/>
		</Layout>
	);
}

export default Pedido;
